/**
 * Sorts items by search relevance: exact match first, then starts-with, then contains.
 * Items with equal relevance are sorted alphabetically via localeCompare.
 */
export const sortBySearchRelevance = (getLabel, search) => (a, b) => {
    const searchLower = search.toLowerCase();
    const score = (label) => {
        const lower = label.toLowerCase();
        if (lower === searchLower) {
            return 0;
        }
        if (lower.startsWith(searchLower)) {
            return 1;
        }
        return 2;
    };
    const diff = score(getLabel(a)) - score(getLabel(b));
    return diff !== 0 ? diff : getLabel(a).localeCompare(getLabel(b));
};
export const sortFromCompareArray = (comparator) => (a, b) => {
    if (!comparator?.includes(a) || !comparator?.includes(b)) {
        return 0;
    }
    const indexA = comparator.findIndex((value) => value === a);
    const indexB = comparator.findIndex((value) => value === b);
    return indexA - indexB;
};
//# sourceMappingURL=sort.utilities.js.map